




















































































































import { Vue, Component } from 'vue-property-decorator'
import { getCategories, addEditCategory, deleteCategory } from '@/api/files/files-base/filesBase'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { Loading } from 'element-ui'

@Component({
  name: 'FilesBaseLabel'
})
export default class extends mixins(DateOption) {
  // data
  params: any = {
    id: 0,
    pid: 0,
    nameEn: '',
    nameZh: '',
    nameZhTw: ''
  }
  secondaryParams: any = {
    id: 0,
    pid: 0,
    nameEn: '',
    nameZh: '',
    nameZhTw: ''
  }
  primaryList: any[] = []
  primaryId: number = 0
  selectedId: number = -1
  selected2ndId: number = -1
  secondaryList: any[] = []
  showAdd: boolean = false
  showAddSecondary: boolean = false
  activeIndex: number = 0
  tabs: any[] = [{
    text: 'iOS',
    value: 0
  }, {
    text: 'Android',
    value: 1
  }]
  loading = false
  tableLoading = false
  tableHeight: number = 500
  // lifecycle
  created() {
    this.getLabelCategory()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  handleTab(index: number) {
    this.activeIndex = index
    this.getLabelCategory()
  }
  // methods
  async getLabelCategory() {
    this.loading = true
    let res = await getCategories({ id: 0, platform: this.platform })
    this.primaryList = res.data.dataList || []
    let prime = this.primaryList[0]
    if (prime && prime.id) {
      this.primaryId = prime.id
      let res = await getCategories({ id: prime.id, platform: this.platform })
      this.secondaryList = res.data.dataList || []
    }
    this.loading = false
  }
  setTableHeight() {
    this.tableHeight = document.body.clientHeight - 240
  }
  async handleClick({ id }: any) {
    this.showAddSecondary = false
    this.primaryId = id
    let res = await getCategories({ id, platform: this.platform })
    this.secondaryList = res.data.dataList || []
  }
  handleAdd(level: number) {
    if (level === 0) {
      this.showAdd = true
    } else {
      this.showAddSecondary = true
    }
  }
  handleEdit(item: any, level: number) {
    if (level === 0) this.selectedId = item.id
    else this.selected2ndId = item.id
  }

  handleDelete(ids: number, level: number) {
    this.$confirm('确认操作吗?', '', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      iconClass: 'far fa-question-circle color-primary',
      customClass: 'tutu-dialog'
    })
      .then(() => {
        deleteCategory({ ids: ids.toString(), platform: this.platform }).then((res: any) => {
          if (res.status.code === 0) {
            this['$message'].success('删除成功')
            this.getLabelCategory()
          } else {
            this['$message'].error('删除失败')
          }
        })
      })
      .catch(() => {})
  }
  cancelAdd(level: number) {
    if (level === 0) {
      this.showAdd = false
    } else {
      this.showAddSecondary = false
    }
  }
  async confirmAdd(level: number) {
    let params = level === 0 ? { ...this.params } : { ...this.secondaryParams }
    params.platform = this.platform
    if (level === 1) {
      params.pid = this.primaryId
    }
    let item: any = {
      id: 0,
      pid: 0,
      nameEn: '',
      nameZh: '',
      nameZhTw: ''
    }
    if (params.nameEn || params.nameZh || params.nameZhTw) {
      await addEditCategory(params)
      if (level === 0) {
        this.showAdd = false
        this.params = item
        await this.getLabelCategory()
      } else {
        this.showAddSecondary = false
        let res = await getCategories({ id: this.primaryId, platform: this.platform })
        this.secondaryParams = item
        this.secondaryList = res.data.dataList || []
      }
    } else {
      this.$message.warning('请输入分类名称')
    }
  }

  async confirmEdit(item: any, level: number = 1) {
    let params = { ...item }
    params.platform = this.platform
    if (params.nameEn || params.nameZh || params.nameZhTw) {
      await addEditCategory(params)
      if (level === 0) {
        this.showAdd = false
        this.selectedId = -1
      } else {
        this.showAddSecondary = false
        this.selected2ndId = -1
      }
    }
  }

  // 防止事件冒泡
  clickPrevent(event: Event) {
    event.preventDefault()
    return false
  }

  // computed
  get disabled() {
    return this.secondaryList.length > 0
  }

  get platform() {
    let arr = ['ios', 'android']
    return arr[this.activeIndex]
  }
}
